function safeGet(e,o){return"__proto__"!=o?e[o]:void 0}module.exports=safeGet;